mutation associateSoftwareToken {
  associateSoftwareToken {
    secretCode
  }
}
